import { IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class ItemDto {
    @ApiProperty()
    @IsOptional()
    itemId?: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Item name should not be empty" })
    itemName: string;

    @ApiProperty()
    bapNo: string;

    @ApiProperty()
    approvalNo: string;

    @ApiProperty()
    type: number;

    @ApiProperty()
    netWeight: number;


    @ApiProperty()
    @IsNotEmpty({ message: "Item code should not be empty" })
    itemCode: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Product code should not be empty" })
    productCode: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Item Category code should not be empty" })
    itemCategoryId: number;
    itemCategoryName?: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Item Sub Category code should not be empty" })
    itemSubCategoryId: number;
    itemSubCategoryName?: string;

    @ApiProperty()
    @IsOptional({ message: "Packing Category code should not be empty" })
    packingCategory: string;

    @ApiProperty()
    @IsOptional({ message: "Brand should not be empty" })
    brandId: number;
    brandName?: string;

    @ApiProperty()
    @IsOptional({ message: "Varient code should not be empty" })
    varientId: number;
    varientName: string;

    @ApiProperty()
    @IsOptional({ message: "UOM should not be empty" })
    uomId: number;
    uom?: string;

    @ApiProperty()
    @IsOptional({ message: "min grade should not be empty" })
    minGrade: number;

    @ApiProperty()
    @IsOptional({ message: "max grade should not be empty" })
    maxGrade: number;

    @ApiProperty()
    @IsOptional({ message: "pouches should not be empty" })
    pouches: number;

    @ApiProperty()
    @IsOptional({ message: "pouch Weight should not be empty" })
    pouchWeight: number;

    @ApiProperty()
    @IsOptional({ message: "Size should not be empty" })
    sizeId: number;
    sizeName?: string;

    @ApiProperty()
    minimumQuantity: number;

    @ApiProperty()
    productId?: number;

    @ApiProperty()
    count?: number;

    @ApiProperty()
    remarks: string;

    @ApiProperty()
    isActive: boolean;
    createdAt: Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Created User allows maximum 40 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "created user should be only numbers" })
    createdUser: string;

    updatedAt: Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Updated User allows maximum 40 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "updated user should be only numbers" })
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;

    @ApiProperty()
    foodTypeId?: number;
    @ApiProperty()
    valueAdditionOneId?: number;
    @ApiProperty()
    valueAdditionTwoId?: number;
    @ApiProperty()
    valueAdditionThreeId?: number;
    @ApiProperty()
    valueAdditionFourId?: number;
    @ApiProperty()
    valueAdditionFiveId?: number;
    @ApiProperty()
    isAsset?: string;
    @ApiProperty()
    assetType?: string;

    @ApiProperty()
    assetSla?:number;

    @ApiProperty()
    assetPriority?:string;

}

